import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Draggable from "./components/Draggable";
// import Accordions from "./components/Accordions";
// import ImageAccordions from "./components/ImageAccordions";
import ImageAccordionsMasonry from "./components/ImageAccordionMasonry";

import InputTextArea from "./components/InputTextArea";
import DragMasonry from "./components/DragMasonry2";
import { useState, useEffect } from "react";
import { splitTextIntoParagraphs } from "./components/brains/splitTextIntoParagraphs";
import { getKeywords } from "./components/brains/getKeywords";
// import "./styles.css";
import { imageGen } from "./components/brains/imageGen";
import Loading from "./components/Loading";
// import Goo from "./components/Goo";
import Stack from "./components/Stackable";
import Heading from "./components/Heading";
function App() {
  const [text, setText] = useState("");
  const [textArr, setTextArr] = useState("");
  const [loading, isLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [keywordsAll, setKeywordsAll] = useState([]);
  // for(let i = 0; i< textArr.length, i++){}
  useEffect(() => {
    if (text) {
      setTextArr(splitTextIntoParagraphs(text));
      var dict = splitTextIntoParagraphs(text).map((paragraph, index) => {
        const keywords = getKeywords(paragraph, 1);
        // setKeywordsAll([...keywordsAll, keywords]);
        if (Array.isArray(keywords) && keywords.length > 0) {
          return {
            keywords: keywords[0],
            paragraph: paragraph
          };
        } else {
          return {
            keywords: "",
            paragraph: paragraph
          };
        }
      });
      setTextArr(dict);
      // console.log("i is dict", dict);
    }
  }, [text]);

  useEffect(() => {
    async function fetchImages() {
      try {
        const urls = await Promise.all(
          textArr?.map(async (theme) => ({
            title: theme.keywords,
            img: await imageGen(theme.keywords)
          }))
        );
        setImageUrls(urls);
      } catch (e) {
        console.log(e);
        console.log("likely image api is maxed out :(");
      } finally {
        isLoading(false);
      }
    }

    if (textArr.length > 0) {
      fetchImages();
    }
  }, [textArr]);

  // NEW callback for text stackable editor
  const handleTextChange = (index, newText) => {
    setTextArr((prevTextArray) =>
      prevTextArray.map((text, i) =>
        i === index ? { ...text, paragraph: newText } : text
      )
    );
  };

  return (
    <div
      className="container"
      // style={{ marginLeft: "40px", marginRight: "40px" }}
    >
      <Draggable>
        <Heading title={" "} />
        <InputTextArea title={"Text Input"} getText={setText} />
        {/* <Accordions textArr={textArr} /> */}
        {textArr && !loading && (
          <DragMasonry
            title={"Rearrange Your Writing"}
            subtitle={"Move your paragraphs around like blocks"}
            textArr={textArr}
          />
        )}
        {textArr && !loading && (
          <Stack
            title={"Paragraph Stacks"}
            subtitle={"Stack and edit your paragaphs"}
            textArray={textArr}
            onTextChange={handleTextChange}
          />
        )}
        {/* {textArr && !loading && (
          <ImageAccordions title={"Paragraphs to Images"} />
        )} */}
        {textArr && imageUrls && !loading && (
          <ImageAccordionsMasonry
            title={"Paragraphs to Images"}
            subtitle={"Transform your essay's paragraphs into images"}
            imageUrls={imageUrls}
            texts={textArr}
          />
        )}
        {loading && <Loading />}
      </Draggable>
    </div>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
